"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptionToggleButton = void 0;
var ToggleButton_1 = require("./ToggleButton");
var i18n_1 = require("../../localization/i18n");
/**
 * A button that toggles the display of captions and subtitles.
 *
 * The button is hidden while the source provides no caption tracks, because there is nothing to
 * toggle in that case.
 *
 * When captions are switched on, the button restores the track that was enabled last. If no track
 * has been enabled yet, it prefers a track matching the current audio language and falls back to
 * the first available track.
 *
 * @category Buttons
 */
var CaptionToggleButton = /** @class */ (function (_super) {
    __extends(CaptionToggleButton, _super);
    function CaptionToggleButton(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, config) || this;
        _this.config = _this.mergeConfig(config, {
            cssClass: 'ui-captiontogglebutton',
            text: i18n_1.i18n.getLocalizer('settings.subtitles'),
            onAriaLabel: i18n_1.i18n.getLocalizer('captions.disable'),
            offAriaLabel: i18n_1.i18n.getLocalizer('captions.enable'),
        }, _this.config);
        return _this;
    }
    CaptionToggleButton.prototype.configure = function (player, uimanager) {
        var _this = this;
        var _a;
        _super.prototype.configure.call(this, player, uimanager);
        // The track to restore when captions are switched back on. Also updated for tracks enabled
        // elsewhere in the UI, so that the button and e.g. the subtitle list box agree on the selection.
        var lastEnabledTrackId;
        // The subtitles API is not available on every player/platform and can still be missing while no
        // source is loaded, so every access has to be guarded.
        var availableTracks = function () { var _a, _b; return (_b = (_a = player.subtitles) === null || _a === void 0 ? void 0 : _a.list()) !== null && _b !== void 0 ? _b : []; };
        var enabledTracks = function () { return availableTracks().filter(function (track) { return track.enabled; }); };
        var trackToEnable = function () {
            var _a, _b, _c;
            var tracks = availableTracks();
            var audioLanguage = (_a = player.getAudio()) === null || _a === void 0 ? void 0 : _a.lang;
            return ((_c = (_b = tracks.find(function (track) { return track.id === lastEnabledTrackId; })) !== null && _b !== void 0 ? _b : tracks.find(function (track) { return track.lang === audioLanguage; })) !== null && _c !== void 0 ? _c : tracks[0]);
        };
        var captionStateHandler = function () {
            if (availableTracks().length === 0) {
                _this.hide();
                return;
            }
            _this.show();
            enabledTracks().length > 0 ? _this.on() : _this.off();
        };
        var subtitleEnabledHandler = function (event) {
            if (event.subtitle) {
                lastEnabledTrackId = event.subtitle.id;
            }
            captionStateHandler();
        };
        var sourceUnloadedHandler = function () {
            // The restored track belongs to the previous source, so it must not leak into the next one.
            lastEnabledTrackId = undefined;
            captionStateHandler();
        };
        player.on(player.exports.PlayerEvent.SourceLoaded, captionStateHandler);
        player.on(player.exports.PlayerEvent.SourceUnloaded, sourceUnloadedHandler);
        player.on(player.exports.PlayerEvent.SubtitleAdded, captionStateHandler);
        player.on(player.exports.PlayerEvent.SubtitleRemoved, captionStateHandler);
        player.on(player.exports.PlayerEvent.SubtitleEnabled, subtitleEnabledHandler);
        player.on(player.exports.PlayerEvent.SubtitleDisabled, captionStateHandler);
        // Tracks can change between periods of the same source.
        player.on(player.exports.PlayerEvent.PeriodSwitched, captionStateHandler);
        uimanager.getConfig().events.onUpdated.subscribe(captionStateHandler);
        this.onClick.subscribe(function () {
            var currentlyEnabledTracks = enabledTracks();
            if (currentlyEnabledTracks.length > 0) {
                currentlyEnabledTracks.forEach(function (track) { return player.subtitles.disable(track.id); });
            }
            else {
                var track = trackToEnable();
                if (track) {
                    player.subtitles.enable(track.id, true);
                }
            }
        });
        // Startup init. The UI can be built lazily, so the initial state has to be derived from the
        // player instead of waiting for the next event.
        lastEnabledTrackId = (_a = enabledTracks().pop()) === null || _a === void 0 ? void 0 : _a.id;
        captionStateHandler();
    };
    return CaptionToggleButton;
}(ToggleButton_1.ToggleButton));
exports.CaptionToggleButton = CaptionToggleButton;
